export const GET_OBJECTIONS = "GET_OBJECTIONS";
export const GET_OBJECTIONS_SUCCESS = "GET_OBJECTIONS_SUCCESS";
export const GET_OBJECTIONS_FAILURE = "GET_OBJECTIONS_FAILURE";

export const GET_SINGLE_OBJECTION = "GET_SINGLE_OBJECTION";
export const GET_SINGLE_OBJECTION_SUCCESS = "GET_SINGLE_OBJECTION_SUCCESS";
export const GET_SINGLE_OBJECTION_FAILURE = "GET_SINGLE_OBJECTION_FAILURE";

export const DELETE_OBJECTION = "DELETE_OBJECTION";
export const DELETE_OBJECTION_SUCCESS = "DELETE_OBJECTION_SUCCESS";
export const DELETE_OBJECTION_FAILURE = "DELETE_OBJECTION_FAILURE";
